import axios from 'axios';
import { configs } from '../app/app-configs';
import { Member } from './model/member.model';

export const getMemberByQrToken = async (qrToken: string): Promise<Member> => {
    return await axios
        .get(`${configs.BASE_URL}/qr/member/${qrToken}`)
        .then((res) => {
            return res.data as Member;
        });
};
